import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvidenceStatusPipe } from './pipes/evidence-status.pipe';
import { EvidenceTypePipe } from './pipes/evidence-type.pipe';
import { EvidenceThumbnailPipe } from './pipes/evidence-thumbnail.pipe';
import { EvidenceImageFallbackDirective } from './directives/evidence-image-fallback.directive';
import { EvidenceDurationPipe } from './pipes/evidence-duration.pipe';
import { EvidenceIsActivePipe } from './pipes/evidence-is-active.pipe';
import { EvidenceTypeCleanPipe } from './pipes/evidence-type-clean.pipe';
import { TimeagoModule } from 'ngx-timeago';
import { EvidenceShareTypePipe } from './pipes/evidence-share-type.pipe';
import { EvidenceStatusBadgePipe } from './pipes/evidence-status-badge.pipe';
import { EvidenceLinkTypePipe } from './pipes/evidence-link-type.pipe';
import { EvidenceLinkActionPipe } from './pipes/evidence-link-action.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    EvidenceStatusPipe,
    EvidenceTypePipe,
    EvidenceThumbnailPipe,
    EvidenceImageFallbackDirective,
    EvidenceDurationPipe,
    EvidenceIsActivePipe,
    EvidenceTypeCleanPipe,
    EvidenceShareTypePipe,
    EvidenceStatusBadgePipe,
    EvidenceLinkTypePipe,
    EvidenceLinkActionPipe,
  ],
  exports: [
    EvidenceStatusPipe,
    EvidenceTypePipe,
    EvidenceThumbnailPipe,
    EvidenceImageFallbackDirective,
    EvidenceDurationPipe,
    EvidenceIsActivePipe,
    EvidenceTypeCleanPipe,
    EvidenceShareTypePipe,
    EvidenceStatusBadgePipe,
    TimeagoModule,
    EvidenceLinkTypePipe,
    EvidenceLinkActionPipe,
  ],
})
export class SharedUtilsEvidenceManagementModule {}
